import React, { useRef } from 'react'
import { Box, Button, Typography, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import HelpIcon from '@mui/icons-material/Help'
import { useApplicationSuiteContext } from '../../../contexts/ApplicationSuiteProvider'

const HelpTab: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { usermeta } = useApplicationSuiteContext()
  const widgetInitialized = useRef(false)

  const openTicketDialog = () => {
    const widget = (window as any).DTUSupportWidget
    if (!widget) return

    if (!widgetInitialized.current) {
      widgetInitialized.current = true
      widget.init({
        baseUrl: 'https://members.daytradeu.com',
        mode: 'popup',
        hidden: true,
        embedType: 'Strategy Suite',
        embedSource: 'GreenChart Strategy Suite',
        prefillName: `${usermeta?.firstName || ''} ${usermeta?.lastName || ''}`.trim(),
        prefillEmail: usermeta?.email || '',
        gcid: usermeta?.gcid || '',
        position: 'bottom-left',
        offsetX: 24,
        offsetY: 24,
      })
    }

    widget.open()
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
        gap: 3,
      }}
    >
      <Box style={{ padding: '56.25% 0 0 0', position: 'relative', width: '100%' }}>
        <iframe
          src="https://vimeo.com/showcase/11829056/embed2"
          allowFullScreen
          frameBorder="0"
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          title={'Strategy Suite Tutorial'}
        ></iframe>
      </Box>

      <Typography
        variant={isMobile ? 'h6' : 'h5'}
        color="text.primary"
        textAlign="center"
        gutterBottom
      >
        Need Help?
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        textAlign="center"
        sx={{ maxWidth: '400px', mb: 2 }}
      >
        Create a support ticket and our team will get back to you as soon as possible.
      </Typography>

      <Button
        variant="contained"
        startIcon={<HelpIcon />}
        onClick={openTicketDialog}
        size={isMobile ? 'medium' : 'large'}
        sx={{
          px: 3,
          py: 1.5,
          borderRadius: 2,
          textTransform: 'none',
          fontSize: isMobile ? '0.875rem' : '1rem',
        }}
      >
        Create Ticket
      </Button>
    </Box>
  )
}

export default HelpTab
